import { signalToObservable } from '@adornis/functional-lit/signal-to-observable';
import { routingStateSignal } from '@adornis/router/client/routing-state-signal';
import { firstValueFrom, timer } from 'rxjs';
import { findElementByIdDeep } from './findElementByIdDeep';
export const registerAnchorDetection = () => {
  signalToObservable(routingStateSignal).subscribe(async routingState => {
    const hash = routingState.hash.slice(1);
    if (!hash) return;

    console.log('anchor detection is checking...', hash);

    for (let i = 0; i < 16; i++) {
      await firstValueFrom(timer(500));
      const scrolledTo = await scrollToAnchor(hash);
      console.log('scrolled to', scrolledTo);
      if (scrolledTo) {
        console.log('anchor detected and scrolled to');
        break;
      } else if (i === 9) {
        console.log('anchor detection failed');
      }
    }
  });
};

function scrollToAnchor(hash: string) {
  return new Promise<boolean>(async (resolve, reject) => {
    const target = findElementByIdDeep(document, hash);

    if (target) {
      const initialPosition = target.getBoundingClientRect().top;

      await firstValueFrom(timer(350));

      requestAnimationFrame(() => {
        const newPosition = target.getBoundingClientRect().top;
        if (initialPosition === newPosition) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.focus();
          resolve(true);
        } else {
          resolve(false);
        }
      });
    } else {
      resolve(false);
    }
  });
}
